import styled from "styled-components";

export const Container = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    height: 100vh;
    justify-content: center;
`;

export const MessageContainer = styled.h3`
    margin: 20px 0px;
`;
